const types = {
  SET_SUGGESTIONSLOADED_SUCCES: "SET_SUGGESTIONSLOADED_SUCCES",
  SET_SUGGESTIONS_DATA: "SET_SUGGESTIONS_DATA",
  SET_PLACES: "SET_PLACES",
  SET_SEARCH_INPUT: "SET_SEARCH_INPUT",
  SET_DETAILS: "SET_DETAILS",
  SET_DETAILS_LOADED_SUCCES: "SET_DETAILS_LOADED_SUCCES",
  SET_SEARCH_INPUT_VIA_STORAGE: "SET_SEARCH_INPUT_VIA_STORAGE",
  SET_RADIUS_DISTANCE: "SET_RADIUS_DISTANCE",
  SET_QUALITY_SCHEME: "SET_QUALITY_SCHEME"
};

export { types };